export const STATIC_ICON_LIST = Object.freeze({
  abuseComment: 'abuse-comment',
  adult: 'adult',
  angleDown: 'angle-down',
  angleDownBlue: 'angle-down-blue',
  angleRight: 'angle-right',
  angleUpBlue: 'angle-up-blue',
  arrowDown: 'arrow-down',
  arrowUpRight: 'arrow-up-right',
  ban: 'ban',
  bell: 'bell',
  bellFill: 'bell-fill',
  blackCloud: 'black-cloud',
  blueCamera: 'blue-camera',
  blueTriangle: 'blue-triangle',
  calendar: 'calendar',
  calendarNext: 'calendar-next',
  calendarPrev: 'calendar-prev',
  camera: 'camera',
  check: 'check',
  checkCircle: 'check-circle',
  checkCircleFill: 'check-circle-fill',
  checkThick: 'check-thick',
  chevronRight: 'chevron-right',
  comment: 'comment',
  commentCircle: 'comment-circle',
  file: 'file',
  flag: 'flag',
  flagBlue: 'flag-blue',
  flagPink: 'flag-pink',
  hamburger: 'hamburger',
  heartMinus: 'heart-minus',
  heartPlus: 'heart-plus',
  home: 'home',
  homeFill: 'home-fill',
  image: 'image',
  imageFill: 'image-fill',
  logo: 'logo',
  middleDot: 'middle-dot',
  mypage: 'mypage',
  mypageFill: 'mypage-fill',
  nestedArrow: 'nested-arrow',
  notificationRed: 'notification-red',
  noticeBell: 'notice-bell',
  point: 'point',
  pointCircle: 'point-circle',
  pointCircleBlue: 'point-circle-blue',
  pencil: 'pencil',
  pencilBlue: 'pencil-blue',
  refresh: 'refresh',
  search: 'search',
  searchThick: 'search-thick',
  share: 'share',
  snowCircleBlue: 'snow-circle-blue',
  snowCirclePink: 'snow-circle-pink',
  starCircle: 'star-circle',
  test: 'test',
  testFill: 'test-fill',
  triangleExclamationCircle: 'triangle-exclamation-circle',
  trash: 'trash',
  user: 'user',
  userDisgust: 'user-disgust',
  userStranger: 'user-stranger',
  userSunglasses: 'user-sunglasses',
  video: 'video',
  videoFill: 'video-fill',
  movie: 'movie',
  location: 'location',
  person: 'person',
  host: 'host',
});

export const FILL_ICON_LIST = Object.freeze({
  arrowLeft: 'arrow-left',
  bookmarkFill: 'bookmark-fill',
  clipBoardList: 'clip-board-list',
  closedEye: 'closed-eye',
  like: 'like',
  openedEye: 'opened-eye',
});

export const STROKE_ICON_LIST = Object.freeze({
  pencilUnderline: 'pencil-underline',
  x: 'x',
});

export const ILLUSTRATION_ICON_LIST = Object.freeze({
  starNoComment: 'star-no-comment',
  starNoPost: 'star-no-post',
  starNoReview: 'star-no-review',
});
